/* Phone product page (live 2026-10-11). Loaded on every product template by a custom_liquid block.
   Builds its wrappers at any width; the CSS only styles them on phones. Tap-to-enlarge works at every width. */
(function () {
  var W = window, D = document;

  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_L = CHEV.replace('M9 5l7 7-7 7', 'M15 5l-7 7 7 7');
  function arrow(dir, label) {
    var b = D.createElement('button');
    b.type = 'button';
    b.className = 'ptmt-arr ptmt-arr--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = dir === 'prev' ? CHEV_L : CHEV;
    return b;
  }
  function swipe(el, go) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches.length === 1 ? e.touches[0].clientX : null; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null || e.touches.length) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  /* best large URL from an <img>: the widest srcset entry */
  function big(img) {
    var best = img.currentSrc || img.src, w = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
      var p = c.trim().split(/\s+/), n = parseInt(p[1], 10);
      if (p[0] && n > w) { w = n; best = p[0]; }
    });
    return best;
  }

  function gallery(root) {
    var list = root.querySelector('.main-product__media-list');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.main-product__thumb:not([data-pt3d])')); /* the 3D thumbnail is not a photo (snippets/pt-3d.liquid) */
    if (!list) return;
    var items = thumbs.length
      ? thumbs.map(function (t) { return list.querySelector('[data-media-id="' + t.getAttribute('data-thumb-media-id') + '"]'); })
      : Array.prototype.slice.call(list.querySelectorAll('.main-product__media'));
    function cur() { for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('is-active')) return i; return 0; }
    function show(n) { if (thumbs.length) thumbs[(n + thumbs.length) % thumbs.length].click(); }
    if (thumbs.length > 1) {
      var prev = arrow('prev', 'Previous image'), next = arrow('next', 'Next image');
      prev.addEventListener('click', function () { show(cur() - 1); });
      next.addEventListener('click', function () { show(cur() + 1); });
      list.appendChild(prev);
      list.appendChild(next);
      swipe(list, function (d) { show(cur() + d); });
    }

    /* lightbox: images only (videos and 3D keep their own controls) */
    var pics = [];
    items.forEach(function (it, i) {
      var img = it && it.matches('.main-product__media--image') && it.querySelector('img');
      if (img) pics.push({ i: i, img: img });
    });
    if (!pics.length) return;
    var lb = D.createElement('div');
    lb.className = 'ptmt-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Enlarged product images');
    lb.innerHTML = '<div class="ptmt-lb__bar"><span class="ptmt-lb__n"></span><button type="button" class="ptmt-lb__x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div><div class="ptmt-lb__stage"><img class="ptmt-lb__img" alt=""></div><div class="ptmt-lb__thumbs"></div>';
    var stage = lb.querySelector('.ptmt-lb__stage'), pic = lb.querySelector('.ptmt-lb__img'), num = lb.querySelector('.ptmt-lb__n'), strip = lb.querySelector('.ptmt-lb__thumbs');
    var k = 0, opener = null;
    pics.forEach(function (p, j) {
      var b = D.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (j + 1));
      var t = thumbs[p.i] && thumbs[p.i].querySelector('img');
      var im = D.createElement('img');
      im.alt = '';
      im.loading = 'lazy';
      im.src = t ? t.getAttribute('src') : p.img.currentSrc || p.img.src;
      b.appendChild(im);
      b.addEventListener('click', function () { go(j); });
      strip.appendChild(b);
    });
    if (pics.length > 1) {
      var lp = arrow('prev', 'Previous image'), ln = arrow('next', 'Next image');
      lp.addEventListener('click', function () { go(k - 1); });
      ln.addEventListener('click', function () { go(k + 1); });
      stage.appendChild(lp);
      stage.appendChild(ln);
    } else {
      strip.hidden = true;
      num.hidden = true;
    }
    function go(j) {
      k = (j + pics.length) % pics.length;
      lb.classList.remove('is-zoom');
      pic.style.transformOrigin = '';
      pic.src = big(pics[k].img);
      pic.alt = pics[k].img.alt;
      num.textContent = (k + 1) + ' / ' + pics.length;
      Array.prototype.forEach.call(strip.children, function (b, i) { b.classList.toggle('is-on', i === k); });
    }
    function open(i) {
      opener = D.activeElement;
      var j = 0;
      pics.forEach(function (p, n) { if (p.i === i) j = n; });
      go(j);
      lb.hidden = false;
      D.documentElement.classList.add('ptmt-lock');
      lb.querySelector('.ptmt-lb__x').focus();
    }
    function close() {
      lb.hidden = true;
      D.documentElement.classList.remove('ptmt-lock');
      show(pics[k].i); /* main gallery follows the last image viewed */
      if (opener && opener.focus) opener.focus();
    }
    lb.querySelector('.ptmt-lb__x').addEventListener('click', close);
    /* desktop: click zooms in where clicked and the mouse pans; phones pinch to zoom */
    function origin(e, box) {
      var r = box.getBoundingClientRect();
      pic.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    }
    pic.addEventListener('click', function (e) {
      if (!lb.classList.contains('is-zoom')) origin(e, pic);
      lb.classList.toggle('is-zoom');
    });
    stage.addEventListener('mousemove', function (e) { if (lb.classList.contains('is-zoom')) origin(e, stage); });
    swipe(stage, function (d) { if (!lb.classList.contains('is-zoom') && pics.length > 1) go(k + d); });
    D.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(k - 1);
      else if (e.key === 'ArrowRight') go(k + 1);
    });
    pics.forEach(function (p) {
      p.img.addEventListener('click', function () { open(p.i); });
    });
    D.body.appendChild(lb);
  }

  function priceRow(info) {
    var price = info.querySelector(':scope > .main-product__price');
    var rating = info.querySelector(':scope > .main-product__rating');
    if (!price) return;
    var row = D.createElement('div');
    row.className = 'ptmt-row';
    (rating || price).insertAdjacentElement('beforebegin', row);
    if (rating) row.appendChild(rating);
    row.appendChild(price);
    if (rating) {
      var long = rating.querySelector('.rating__count-long');
      if (long) long.textContent = long.textContent.replace(/\s*reviews?$/i, '');
    }
    function tidy() { /* "Save $304.00" -> "Save $304" */
      var s = price.querySelector('.price__save');
      if (s && /\.00\b/.test(s.textContent)) s.textContent = s.textContent.replace(/\.00\b/, '');
    }
    tidy();
    new MutationObserver(tidy).observe(price, { childList: true, subtree: true, characterData: true });
  }

  function gifts(g) {
    g.classList.add('ptmt-gifts');
    var t = g.querySelector('.pt-gifts__title');
    if (t) t.textContent = 'Pick your free gifts';
  }

  function eta() { /* "Oct 13 to 19" -> "Oct 13-19" so "Arrives Oct 13-19" fits one line */
    var e = D.querySelector('.pib-p__block--eta pt-eta');
    if (!e) return;
    function fix() { if (/ to /.test(e.textContent)) e.textContent = e.textContent.replace(/ to /, '-'); }
    fix();
    new MutationObserver(fix).observe(e, { childList: true, characterData: true, subtree: true });
  }

  function run() {
    var info = D.querySelector('.main-product__info');
    if (!info) return;
    D.documentElement.classList.add('ptmt');
    var gal = D.querySelector('.main-product__gallery');
    if (gal) gallery(gal);
    priceRow(info);
    eta();
    var g = info.querySelector('pt-free-gifts');
    if (g) gifts(g);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', run); else run();
})();
